import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { getRole, isLoggedIn } from '../core/session';
import { customerRole, candidateRole } from '../core/constants';

const AnonymousOnlyRoute = ({ children }: { children: JSX.Element }) => {
	return isLoggedIn() ? <Navigate to={getLoggedRedirectPath()} replace /> : children;
};

const getLoggedRedirectPath = () => {
	const role = getRole();
	switch (role) {
		case customerRole:
			return '/candidates';
		case candidateRole:
			return '/dashboard';
		default:
			throw new Error(`Unknown role: ${role}.`);
	}
};

export default AnonymousOnlyRoute;
